import React from 'react';
import { Send, Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';

export const ReminderDialog = ({ open, onOpenChange, count, selectedInvoices, processing, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="reminder-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Send className="h-5 w-5 text-blue-600" />
          Send Payment Reminders
        </DialogTitle>
        <DialogDescription>
          Send payment reminder emails and in-app notifications to clients
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 pt-2">
        <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm">
          <p className="text-blue-800">
            <strong>{count}</strong> invoice{count > 1 ? 's' : ''} selected for reminders.
            Clients will receive both email and in-app notifications.
          </p>
        </div>

        <div className="space-y-2 max-h-40 overflow-y-auto">
          {selectedInvoices.slice(0, 5).map(inv => (
            <div key={inv.id} className="flex justify-between text-sm p-2 bg-gray-50 rounded">
              <span>{inv.invoice_number}</span>
              <span className="text-gray-500">{inv.client_name}</span>
            </div>
          ))}
          {selectedInvoices.length > 5 && (
            <p className="text-sm text-gray-500 text-center">+ {selectedInvoices.length - 5} more</p>
          )}
        </div>

        <div className="flex gap-2 pt-2">
          <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button className="flex-1 bg-blue-600 hover:bg-blue-700" onClick={onConfirm} disabled={processing} data-testid="confirm-reminder-btn">
            {processing ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Send className="h-4 w-4 mr-2" />}
            {processing ? 'Sending...' : 'Send Reminders'}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
